// extracted by mini-css-extract-plugin
export default {"container":"Tl-z","blurb":"Ul-z","links":"Vl-z"};